// @ts-nocheck
import { sanitizeNullsDeep } from "@/lib/form/sanitize";

export interface ApprovalLog {
    id: string;
    action: string;
    status: string;
    notes?: string;
    createdAt: string;
    user?: {
        id: string;
        fullName: string;
        email?: string;
    };
}

export interface ProductionOrderApi {
    id: string;
    // Hỗ trợ cả snake_case (legacy) và camelCase (Prisma)
    order_id?: string;
    orderId?: string;
    lsx_id?: string;
    po_reference?: string;
    poReference?: string;
    sales_order_id?: string;
    salesOrderId?: string;
    orderDetailId?: string;
    product_id?: string;
    productId?: string;
    product_name?: string;
    productName?: string;
    customer_id?: string;
    customerId?: string;
    qty_order?: number;
    qtyOrder?: number;
    qty_plan?: number;
    qtyPlan?: number;
    qty_allowance?: number;
    qtyAllowance?: number;
    status: string;
    priority?: string;
    deadline?: string;
    progress?: number;
    current_step?: string;
    currentStep?: string;
    prepress_status?: string;
    prepressStatus?: string;
    machine_id?: string;
    machineId?: string;
    created_at?: string;
    createdAt?: string;
    updated_at?: string;
    updatedAt?: string;
    product?: {
        id: string;
        name: string;
        qty_plan?: number;
        qtyPlan?: number;
        qty_allowance?: number;
        qtyAllowance?: number;
        customer_id?: string;
        customerId?: string;
    };
    tech_specs?: unknown;
    techSpecs?: unknown;
    bom_estimator?: unknown;
    bomEstimator?: unknown;
    routing?: unknown[];
    routingSteps?: unknown[];
    qc_records?: unknown[];
    qcRecords?: unknown[];
    materialPlans?: unknown[];
    salesOrder?: {
        id: string;
        orderId?: string;
        poNumber?: string;
        customer?: { id: string; code?: string; name?: string; shortName?: string };
    };
    isPlanLocked?: boolean;
    technicalSpec?: { id: string; specId: string; name: string };
    techSpecId?: string;
    dieCuts?: { id: string; dieCutId: string; name: string }[];
    plates?: { id: string; plateId: string; name: string }[];
    approvalLogs?: ApprovalLog[];
    components?: unknown[];
    orderSources?: unknown[];
    productionOrderSources?: any[];
    notes?: string;
    dieCutMoldStatus?: string;
    foilMoldStatus?: string;
    silkScreenMoldStatus?: string;
    zincPlateStatus?: string;
    prepressPcsPerSheet?: number;
    prepressWasteAllowance?: number;
    prepressWastePercentage?: number;
    totalTargetQty?: number;
    totalPlanSheets?: number;
    purchasedPaperSize?: string;
    printingPaperSize?: string;
    cutRatio?: number;
    totalMaterialRequired?: number;
    specification?: string;
    standardQuantity?: number;
    allowance?: number;
    deploymentModel?: string;
    actualQuantity?: number;
    isComposite?: boolean;
    toolings?: unknown[];
}

export interface ProductionOrderListItem {
    id: string;
    orderId: string;
    lsxId?: string;
    poReference?: string;
    salesOrderId?: string;
    productId?: string;
    productName?: string;
    customerId?: string;
    qtyOrder?: number;
    qtyPlan?: number;
    qtyAllowance?: number;
    status: string;
    priority?: string;
    deadline?: string;
    progress?: number;
    materialStatus?: string;
    toolingStatus?: string;
    prepressStatus?: string;
    createdAt?: string;
    updatedAt?: string;
    product?: {
        id: string;
        name: string;
        qtyPlan: number;
        qtyAllowance?: number;
        customerId?: string;
        technicalSpecId?: string;
        productCode?: string;
        image?: string | null;
    };
    printLayouts?: { id: string; fileUrl?: string | null }[];
    salesOrder?: {
        id: string;
        orderId?: string;
        customer?: { id: string; code?: string; name?: string; shortName?: string };
    };
    processGroupMetrics?: Record<string, any>;
    routingSteps?: any[];
    materials?: any[];
    toolings?: any[];
    prepress?: any;
}

export interface ProductionQueueItem {
    lsxId: string;
    productName: string;
    customer: string;
    currentStep: string;
    machineId: string;
    progress: number;
    status: string;
    toolings?: unknown[];
}

export interface ProductionOrderDetail {
    id: string;
    orderId: string;
    lsxId?: string;
    poReference?: string;
    salesOrderId?: string;
    orderDetailId?: string;
    productId?: string;
    productName?: string;
    customerId?: string;
    qtyOrder?: number;
    qtyPlan?: number;
    qtyAllowance?: number;
    status: string;
    priority?: string;
    deadline?: string;
    materialStatus?: string;
    toolingStatus?: string;
    plateStatus?: string;
    moldStatus?: string;
    isPlateExported?: boolean;
    isFileApproved?: boolean;
    prepressStatus?: string;
    techSpecs?: unknown;
    bomEstimator?: unknown;
    routing: unknown[];
    routingSteps?: unknown[];
    qcRecords: unknown[];
    product?: {
        id?: string;
        name?: string;
        qtyPlan?: number;
        qtyAllowance?: number;
        customerId?: string;
    };
    materialPlans: unknown[];
    salesOrder?: {
        id: string;
        orderId?: string;
        customer?: { id: string; code?: string; name?: string; shortName?: string };
    };
    isPlanLocked?: boolean;
    technicalSpec?: { id: string; specId: string; name: string };
    techSpecId?: string;
    dieCuts?: { id: string; dieCutId: string; name: string }[];
    plates?: { id: string; plateId: string; name: string }[];
    approvalLogs?: ApprovalLog[];
    components?: unknown[];
    orderSources?: unknown[];
    notes?: string;
    dieCutMoldStatus?: string;
    foilMoldStatus?: string;
    silkScreenMoldStatus?: string;
    zincPlateStatus?: string;
    prepressPcsPerSheet?: number;
    prepressWasteAllowance?: number;
    prepressWastePercentage?: number;
    totalTargetQty?: number;
    totalPlanSheets?: number;
    purchasedPaperSize?: string;
    printingPaperSize?: string;
    cutRatio?: number;
    totalMaterialRequired?: number;
    specification?: string;
    standardQuantity?: number;
    allowance?: number;
    deploymentModel?: string;
    actualQuantity?: number;
    isComposite?: boolean;
    toolings?: unknown[];
    materials?: any[];
    prepress?: any;
    sheetSize?: string;
    ups?: number;
}

export function mapProductionOrderListItem(apiOrder: ProductionOrderApi): ProductionOrderListItem {
    return {
        id: apiOrder.id,
        orderId: apiOrder.orderId || apiOrder.order_id || apiOrder.id,
        lsxId: apiOrder.lsx_id || apiOrder.orderId || apiOrder.order_id,
        poReference: apiOrder.poReference || apiOrder.po_reference,
        salesOrderId: apiOrder.salesOrderId || apiOrder.sales_order_id,
        productId: apiOrder.productId || apiOrder.product_id,
        productName: apiOrder.productName || apiOrder.product_name || apiOrder.product?.name,
        customerId: apiOrder.customerId || apiOrder.customer_id || apiOrder.product?.customer_id || apiOrder.product?.customerId,
        qtyOrder: apiOrder.qtyOrder ?? apiOrder.qty_order,
        qtyPlan: apiOrder.qtyPlan ?? apiOrder.qty_plan ?? apiOrder.product?.qtyPlan ?? apiOrder.product?.qty_plan,
        qtyAllowance: apiOrder.qtyAllowance ?? apiOrder.qty_allowance ?? apiOrder.product?.qtyAllowance ?? apiOrder.product?.qty_allowance,
        status: apiOrder.status,
        priority: apiOrder.priority,
        deadline: apiOrder.deadline || (apiOrder.salesOrder as any)?.deliveryDeadline || (apiOrder.salesOrder as any)?.orderDate || apiOrder.createdAt || (apiOrder as any).created_at,
        progress: apiOrder.progress || 0,
        materialStatus: (apiOrder as any).materialStatus || "PENDING",
        toolingStatus: (apiOrder as any).toolingStatus || "PENDING",
        prepressStatus: apiOrder.prepressStatus || apiOrder.prepress_status || "PENDING",
        createdAt: apiOrder.createdAt || apiOrder.created_at,
        updatedAt: apiOrder.updatedAt || apiOrder.updated_at,
        product: apiOrder.product ? {
            id: apiOrder.product.id,
            name: apiOrder.product.name,
            qtyPlan: apiOrder.product.qtyPlan ?? apiOrder.product.qty_plan ?? 0,
            qtyAllowance: apiOrder.product.qtyAllowance ?? apiOrder.product.qty_allowance,
            customerId: apiOrder.product.customerId || apiOrder.product.customer_id,
            technicalSpecId: (apiOrder.product as any).technicalSpecs?.[0]?.specId,
            productCode: (apiOrder.product as any).productCode,
            image: (apiOrder.product as any).image ?? null,
        } : undefined,
        printLayouts: (apiOrder as any).printLayouts,
        salesOrder: apiOrder.salesOrder,
        processGroupMetrics: (apiOrder as any).processGroupMetrics,
        routingSteps: (apiOrder as any).routingSteps,
        materials: (apiOrder as any).materials,
        toolings: (apiOrder as any).toolings,
        prepress: (apiOrder as any).prepress,
    };
}

export function mapProductionOrderDetail(apiOrder: ProductionOrderApi): ProductionOrderDetail {
    const prepress = (apiOrder as any).prepress;
    const prepressPcsPerSheet = prepress?.prepressPcsPerSheet ?? (apiOrder as any).prepressPcsPerSheet ?? (apiOrder as any).ups ?? 1;
    const prepressWasteAllowance = prepress?.prepressWasteAllowance ?? (apiOrder as any).prepressWasteAllowance ?? null;
    const prepressWastePercentage = prepress?.prepressWastePercentage ?? (apiOrder as any).prepressWastePercentage ?? 2.0;
    const totalTargetQty = prepress?.totalTargetQty ?? (apiOrder as any).totalTargetQty ?? apiOrder.qtyPlan ?? apiOrder.qtyOrder ?? null;
    const totalPlanSheets = prepress?.totalPlanSheets ?? (apiOrder as any).totalPlanSheets ?? (apiOrder as any).runSheetsNeeded ?? null;

    const firstMaterial = (apiOrder as any).materials?.[0];
    const techSpecsObj = (apiOrder.techSpecs || (apiOrder as any).tech_specs || {}) as any;
    const purchasedPaperSize = firstMaterial?.purchasedPaperSize ?? (apiOrder as any).purchasedPaperSize ?? techSpecsObj?.paperSize ?? "";
    const printingPaperSize = firstMaterial?.printingPaperSize ?? (apiOrder as any).printingPaperSize ?? (apiOrder as any).sheetSize ?? techSpecsObj?.printingPaperSize ?? "";
    const cutRatio = firstMaterial?.cutRatio ?? (apiOrder as any).cutRatio ?? null;
    const totalMaterialRequired = firstMaterial?.totalMaterialRequired ?? (apiOrder as any).totalMaterialRequired ?? null;
    const specification = firstMaterial?.specification ?? (apiOrder as any).specification ?? null;
    const standardQuantity = firstMaterial?.standardQuantity ?? (apiOrder as any).standardQuantity ?? null;
    const allowance = firstMaterial?.allowance ?? (apiOrder as any).allowance ?? null;

    const notes = (apiOrder as any).notes ?? techSpecsObj?.notes ?? "";

    const rawToolings = (apiOrder as any).toolings || [];
    const toolings = Array.isArray(rawToolings) && rawToolings.length > 0
        ? rawToolings.map((t: any) => ({
            ...t,
            toolingType: t.toolingType || 'DIE_CUT',
            toolingId: t.dieCutId || t.toolingId || t.id,
            dieCutId: t.dieCutId || (t.toolingType === 'DIE_CUT' ? (t.toolingId || t.id) : undefined),
            status: t.status || 'NEW',
            notes: t.notes || '',
          }))
        : [];

    const rawComponents = (apiOrder as any).components || [];
    const directRouting = (apiOrder as any).routingSteps || (apiOrder as any).routing || [];
    const directBOM = (apiOrder as any).bomItems || (apiOrder as any).boms || [];

    let components: any[] = [];
    if (Array.isArray(rawComponents) && rawComponents.length > 0) {
        components = rawComponents.map((c: any) => ({
            ...sanitizeNullsDeep(c),
            routingSteps: c.routingSteps || [],
            bomItems: c.bomItems || [],
        }));
    } else if (directRouting.length > 0 || directBOM.length > 0) {
        components = [{
            componentName: "Main",
            isMain: true,
            techSpecs: techSpecsObj,
            routingSteps: directRouting,
            bomItems: directBOM,
        }];
    }

    return {
        id: apiOrder.id,
        orderId: apiOrder.orderId || apiOrder.order_id || apiOrder.id,
        lsxId: apiOrder.lsx_id || apiOrder.orderId || apiOrder.order_id,
        poReference: apiOrder.poReference || apiOrder.po_reference,
        salesOrderId: apiOrder.salesOrderId || apiOrder.sales_order_id,
        orderDetailId: apiOrder.orderDetailId,
        productId: apiOrder.productId || apiOrder.product_id,
        productName: apiOrder.productName || apiOrder.product_name,
        customerId: apiOrder.customerId || apiOrder.customer_id,
        qtyOrder: apiOrder.qtyOrder ?? apiOrder.qty_order,
        qtyPlan: apiOrder.qtyPlan ?? apiOrder.qty_plan,
        qtyAllowance: apiOrder.qtyAllowance ?? apiOrder.qty_allowance,
        status: apiOrder.status,
        priority: apiOrder.priority,
        deadline: apiOrder.deadline,
        materialStatus: (apiOrder as any).materialStatus || (apiOrder as any).material_status,
        toolingStatus: (apiOrder as any).toolingStatus || (apiOrder as any).tooling_status,
        plateStatus: (apiOrder as any).plateStatus || (apiOrder as any).plate_status,
        moldStatus: (apiOrder as any).moldStatus || (apiOrder as any).mold_status,
        isPlateExported: (apiOrder as any).isPlateExported ?? (apiOrder as any).is_plate_exported,
        isFileApproved: (apiOrder as any).isFileApproved ?? (apiOrder as any).is_file_approved,
        prepressStatus: apiOrder.prepressStatus || apiOrder.prepress_status,
        techSpecs: apiOrder.techSpecs || apiOrder.tech_specs,
        bomEstimator: apiOrder.bomEstimator || apiOrder.bom_estimator,
        routing: directRouting,
        routingSteps: directRouting,
        qcRecords: apiOrder.qcRecords || apiOrder.qc_records || [],
        product: (apiOrder as any).product ? {
            ...(apiOrder as any).product,
            id: (apiOrder as any).product.id || apiOrder.productId || apiOrder.product_id,
            name: (apiOrder as any).product.productName || (apiOrder as any).product.name || apiOrder.productName || apiOrder.product_name,
            productCode: (apiOrder as any).product.productCode || (apiOrder as any).product.code,
            image: (apiOrder as any).product.image,
            qtyPlan: apiOrder.qtyPlan ?? apiOrder.qty_plan,
            qtyAllowance: apiOrder.qtyAllowance ?? apiOrder.qty_allowance,
            customerId: apiOrder.customerId || apiOrder.customer_id,
        } : {
            id: apiOrder.productId || apiOrder.product_id,
            name: apiOrder.productName || apiOrder.product_name,
            qtyPlan: apiOrder.qtyPlan ?? apiOrder.qty_plan,
            qtyAllowance: apiOrder.qtyAllowance ?? apiOrder.qty_allowance,
            customerId: apiOrder.customerId || apiOrder.customer_id,
        },
        materialPlans: (apiOrder as any).materialPlans || [],
        salesOrder: (apiOrder as any).salesOrder || undefined,
        isPlanLocked: apiOrder.isPlanLocked ?? (apiOrder as any).is_plan_locked,
        technicalSpec: apiOrder.technicalSpec,
        techSpecId: apiOrder.techSpecId || apiOrder.technicalSpec?.id,
        dieCuts: apiOrder.dieCuts || [],
        plates: apiOrder.plates || [],
        approvalLogs: apiOrder.approvalLogs || [],
        components,
        productionOrderSources: ((apiOrder as any).productionOrderSources || (apiOrder as any).orderSources || []).map((s: any) => {
            const resolvedProd = s.orderDetail?.product || s.product || (apiOrder as any).product;
            return {
                ...sanitizeNullsDeep(s),
                product: resolvedProd,
                productId: s.productId || s.orderDetail?.productId || s.orderDetail?.product?.id || resolvedProd?.id || (apiOrder as any).productId,
                productCode: s.productCode || s.orderDetail?.product?.productCode || resolvedProd?.productCode || (apiOrder as any).product?.productCode,
                productName: s.productName || s.orderDetail?.productName || s.orderDetail?.product?.productName || resolvedProd?.productName || resolvedProd?.name,
            };
        }),
        orderSources: (apiOrder.orderSources || (apiOrder as any).productionOrderSources || []).map((s: any) => {
            const qty = s.quantity || s.qtyOrder || 0;
            const plannedQty = s.plannedQty !== undefined && s.plannedQty !== null ? s.plannedQty : Math.ceil(qty * 1.05);
            const pcsPerSheet = s.pcsPerSheet || s.ups || s.outs || 1;
            const finishedQty = s.finishedQty ?? s.orderDetail?.producedQty ?? 0;
            const deliveredQty = s.deliveredQty ?? s.orderDetail?.qtyDelivered ?? 0;
            const inventoryQty = s.inventoryQty ?? 0;
            const progressPercent = s.progressPercent ?? (plannedQty > 0 ? Math.min(100, Math.round((finishedQty / plannedQty) * 100)) : 0);
            const resolvedProd = s.orderDetail?.product || s.product || (apiOrder as any).product;

            return {
                ...sanitizeNullsDeep(s),
                salesOrderId: s.salesOrderId || s.orderDetail?.orderId || s.orderDetail?.order?.id,
                productName: s.productName || s.orderDetail?.productName || s.orderDetail?.product?.name || resolvedProd?.productName,
                product: resolvedProd,
                productId: s.productId || s.orderDetail?.productId || s.orderDetail?.product?.id || resolvedProd?.id || (apiOrder as any).productId,
                productCode: s.productCode || s.orderDetail?.product?.productCode || resolvedProd?.productCode || (apiOrder as any).product?.productCode,
                quantity: qty,
                plannedQty,
                pcsPerSheet,
                finishedQty,
                deliveredQty,
                inventoryQty,
                progressPercent,
                outs: pcsPerSheet,
            };
        }),
        notes,
        toolings,
        dieCutMoldStatus: apiOrder.dieCutMoldStatus,
        foilMoldStatus: apiOrder.foilMoldStatus,
        silkScreenMoldStatus: apiOrder.silkScreenMoldStatus,
        zincPlateStatus: apiOrder.zincPlateStatus,
        prepressPcsPerSheet,
        prepressWasteAllowance,
        prepressWastePercentage,
        totalTargetQty,
        totalPlanSheets,
        runSheetsNeeded: (apiOrder as any).runSheetsNeeded ?? totalPlanSheets ?? undefined,
        netSheets: (apiOrder as any).netSheets ?? undefined,
        purchasedPaperSize,
        printingPaperSize,
        cutRatio,
        totalMaterialRequired,
        specification,
        standardQuantity,
        allowance,
        deploymentModel: apiOrder.deploymentModel,
        actualQuantity: apiOrder.actualQuantity,
        isComposite: apiOrder.isComposite,
        printLayouts: (apiOrder as any).printLayouts || [],
        materials: (apiOrder as any).materials || [],
        prepress: prepress || undefined,
        sheetSize: printingPaperSize || (apiOrder as any).sheetSize,
        ups: prepressPcsPerSheet,
    };
}

export function mapProductionOrderQueueItem(apiOrder: any): ProductionQueueItem {
    return {
        lsxId: apiOrder.lsx_id || apiOrder.orderId || apiOrder.order_id || apiOrder.id,
        productName: apiOrder.productName || apiOrder.product_name || "N/A",
        customer: apiOrder.salesOrder?.customer?.name || apiOrder.salesOrder?.customer?.shortName || apiOrder.productName || "N/A",
        currentStep: apiOrder.currentStep || apiOrder.current_step || "Chờ phân công",
        machineId: apiOrder.machineId || apiOrder.machine_id || "N/A",
        progress: apiOrder.progress || 0,
        status: apiOrder.status,
    };
}

/**
 * Chuẩn hóa và hiển thị số lượng theo đơn vị tính công đoạn (UOM & UPS)
 * - In Offset, Cán màng, Cắt xén: đơn vị tờ in (SHEET)
 * - Nếu có UPS > 1: hiển thị tương đương số hộp thành phẩm
 * - Bế, Dán, Đóng gói: đơn vị hộp/sp (PCS)
 */
export function formatProcessQuantity(qty: number, stepId?: string, ups?: number): string {
    if (!qty && qty !== 0) return '0';
    if (stepId === 'PROC-IN' && ups && ups > 1) {
        const productEquivalent = qty * ups;
        return `${qty.toLocaleString('vi-VN')} tờ (~${productEquivalent.toLocaleString('vi-VN')} hộp @ ${ups} ups)`;
    }
    const uom = (stepId && ['PROC-IN', 'PROC-CAN', 'PROC-XEN'].includes(stepId)) ? 'tờ' : 'hộp';
    return `${qty.toLocaleString('vi-VN')} ${uom}`;
}

